import React from 'react';
import classes from './CommonNavItem.scss';

const commonNavItem = (props) => <li {...props} className={[classes.Item, props.active === 'true' ? classes.ItemActive : null].join(' ')}>{props.children}</li>;

export default commonNavItem;


// WEBPACK FOOTER //
// ./src/components/Addons/Common/CommonNavItem/CommonNavItem.js